import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { fetchPublicTransportAccess } from "../../../api/transportPublicApi";
import {
  TransportPublicAttribution,
  TransportPublicCtas,
  TransportPublicHero,
  TransportPublicMetrics,
  TransportPublicReportsList,
} from "../../../components/midpoint/transport/public/TransportPublicSections";
import { useTransportPublicSeo, trackTransportPublicEvent } from "../../../hooks/useTransportPublicSeo";
import TransportPublicLayout from "./TransportPublicLayout";

const TransportAccessPage = () => {
  const { areaSlug } = useParams();
  const [payload, setPayload] = useState(null);
  const [error, setError] = useState(null);

  useTransportPublicSeo(payload?.seo);

  useEffect(() => {
    let cancelled = false;
    fetchPublicTransportAccess(areaSlug)
      .then((body) => {
        if (!cancelled) {
          setPayload(body);
          trackTransportPublicEvent("transport_public_page_view", {
            pageType: "access",
            slug: areaSlug,
          });
        }
      })
      .catch((err) => {
        if (!cancelled) setError(err.message || "Unable to load page.");
      });
    return () => {
      cancelled = true;
    };
  }, [areaSlug]);

  if (error || !payload) {
    return (
      <TransportPublicLayout title="Transport access">
        <p>{error || "Loading transport access…"}</p>
      </TransportPublicLayout>
    );
  }

  return (
    <TransportPublicLayout title="Transport access">
      <TransportPublicHero hero={payload.hero} freshness={payload.freshness} />
      <TransportPublicMetrics metrics={payload.keyMetrics} />
      <TransportPublicReportsList mobilityRisks={payload.mobilityRisks} />
      <TransportPublicAttribution
        attribution={payload.attribution}
        methodology={payload.methodology}
      />
      <TransportPublicCtas ctas={payload.ctas} />
    </TransportPublicLayout>
  );
};

export default TransportAccessPage;
